import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './Router';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from './styles/theme';

// Global CSS
import './styles/global.css';

console.log('React is initializing...'); // Add console log for debugging

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter />
    </ThemeProvider>
  </React.StrictMode>
);